import * as apiValues from '../constants/apiValues';
import * as helpers from '../helpers';
import * as mProjectListMapActions from '../actions/mProjectListMapActions';
import * as projectTypeListActions from '../actions/projectTypeListActions';
import iconViewGrid from '../img/icons/icon-view-grid.svg';
import iconViewMap from '../img/icons/icon-view-map.svg';
import MapParent from './MapParent';
import MListNav from './MListNav';
import ProjectList from './ProjectList';
import ProjectTypeList from './ProjectTypeList';
import PropTypes from 'prop-types';
import React from 'react';
import Select from './Select';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { SiteSearch } from './SiteSearch';
import { withRouter } from '../withRouterCompat';


class MProjectListMap extends React.Component{
  lastAppliedSearch = '';

  constructor(props){
    super(props);

    this.state = {
      mapNearByProjects: [],
      searchBusy: false,
    };
    this.filteringApply_onClick = this.filteringApply_onClick.bind(this);
    this.filteringCancel_onClick = this.filteringCancel_onClick.bind(this);
    this.filteringClear_onClick = this.filteringClear_onClick.bind(this);
    this.filteringClose_onClick = this.filteringClose_onClick.bind(this);
    this.filterProjectsButton_onClick = this.filterProjectsButton_onClick.bind(this);
    this.loadMoreButton_onClick = this.loadMoreButton_onClick.bind(this);
    this.loadMoreButton_onClick = this.loadMoreButton_onClick.bind(this);
    this.programsSelect_onChange = this.programsSelect_onChange.bind(this);
    this.projectStatus_onChange = this.projectStatus_onChange.bind(this);
    this.projectTypeList_onFilter = this.projectTypeList_onFilter.bind(this);
    this.search_onBlur = this.search_onBlur.bind(this);
    this.search_onClearClick = this.search_onClearClick.bind(this);
    this.search_onFocus = this.search_onFocus.bind(this);
    this.search_onInputChange = this.search_onInputChange.bind(this);
    this.search_onSubmit = this.search_onSubmit.bind(this);
    this.viewToggle_listView_onClick = this.viewToggle_listView_onClick.bind(this);
    this.viewToggle_mapView_onClick = this.viewToggle_mapView_onClick.bind(this);
    this._draftQuery = '';
    this.debouncedDoSearch = helpers.debounceEvent((query) => {
      Promise.resolve(this.props.actions.mProjectListMap.doSearch(query))
        .then(() => {
          if(this._draftQuery === query){
            this.setState({searchBusy: false});
          }
        })
        .catch(() => {
          if(this._draftQuery === query){
            this.setState({searchBusy: false});
          }
        });
    }, 300);
  }
  componentDidMount(){
    this.syncFromLocation(this.props.location.search, true);
  }
  componentWillUnmount(){
    this.debouncedDoSearch.cancel();
  }
  componentDidUpdate(prevProps){
    if(prevProps.location.search !== this.props.location.search){
      this.syncFromLocation(this.props.location.search);
      return;
    }

    const prevProjectTypes = (prevProps.mProjectListMap.filter_projectType || []).join(',');
    const nextProjectTypes = (this.props.mProjectListMap.filter_projectType || []).join(',');
    if(prevProjectTypes !== nextProjectTypes){
      this.props.actions.projectTypeList.filterList(this.props.mProjectListMap.filter_projectType || []);
    }
  }
  syncFromLocation(search, isMount = false){
    const normalizedSearch = search || '';
    if(!isMount && normalizedSearch === this.lastAppliedSearch){
      return;
    }
    this.lastAppliedSearch = normalizedSearch;

    const urlParams = helpers.parseUrlSearch(normalizedSearch);
    const filters = helpers.buildProjectListFiltersFromUrlSearch(normalizedSearch);
    const projectTypeIds = filters.ProjectTypes_in || [];
    const searchKeyword = urlParams.q || '';

    if(!this.props.mProjectListMap.programs){
      this.props.actions.mProjectListMap.init(filters);
    }
    else{
      this.props.actions.mProjectListMap.setViewMap(!!filters.viewMap);
      this.props.actions.mProjectListMap.filterList(filters);
    }

    if(!this.props.mProjectListMap.programs){
      this.props.actions.projectTypeList.filterList(projectTypeIds);
    }
    if(searchKeyword){
      this.handleSearch(searchKeyword);
    }
  }


  filteringApply_onClick = () => {
    this.props.actions.mProjectListMap.toggleMobileFiltering(false);

    this.props.actions.mProjectListMap.setFilterInputs({
      filter_program: this.props.mProjectListMap.filter_program_temp,
      filter_projectStatus: this.props.mProjectListMap.filter_projectStatus_temp,
      filter_projectType: this.props.mProjectListMap.filter_projectType_temp,
      programSelect: this.props.mProjectListMap.programSelect_temp,
      projectStatusSelect: this.props.mProjectListMap.projectStatusSelect_temp
    });
    this.filterList({
      filter_program: this.props.mProjectListMap.filter_program_temp,
      filter_projectStatus: this.props.mProjectListMap.filter_projectStatus_temp,
      filter_projectType: this.props.mProjectListMap.filter_projectType_temp
    });
  };
  filteringCancel_onClick = () => {
    this.props.actions.mProjectListMap.setFilterInputs({
      filter_program: this.props.mProjectListMap.filter_program || '',
      filter_projectStatus: this.props.mProjectListMap.filter_projectStatus || '',
      filter_projectType: this.props.mProjectListMap.filter_projectType || '',
      programSelect: this.props.mProjectListMap.filter_program || '',
      projectStatusSelect: this.props.mProjectListMap.filter_projectStatus || ''
    });
    this.props.actions.mProjectListMap.toggleMobileFiltering(false);
    this.props.actions.projectTypeList.filterList(this.props.mProjectListMap.filter_projectType);
  };
  filteringClear_onClick = () => {
    this.props.actions.mProjectListMap.setFilterInputs({
      filter_program_temp: '',
      filter_projectStatus_temp: '',
      filter_projectType_temp: '',
      programSelect: '',
      projectStatusSelect: ''
    });
    this.props.actions.projectTypeList.filterList();
  };
  filteringClose_onClick = () => {
    this.filteringCancel_onClick();
  };
  filterProjectsButton_onClick = () => {
    //todo: should this be setting ProgramSelectTemp & ProjectStatusTemp?
    this.props.actions.mProjectListMap.setFilterInputs({
      filter_program_temp: this.props.mProjectListMap.filter_program,
      filter_projectStatus_temp: this.props.mProjectListMap.filter_projectStatus,
      filter_projectType_temp: this.props.mProjectListMap.filter_projectType,
      programSelect: this.props.mProjectListMap.programSelect,
      projectStatusSelect: this.props.mProjectListMap.projectStatusSelect
    });
    this.props.actions.mProjectListMap.toggleMobileFiltering(true);
  };
  loadMoreButton_onClick = () => {
    this.props.actions.mProjectListMap.loadMore();
  };
  programsSelect_onChange = (value) => {
    //console.log(`programsSelect_onChange`, this.props, value);
    if(this.props.mProjectListMap.isFilteringOpen)
      this.props.actions.mProjectListMap.setFilterInputs({
        filter_program_temp: value,
        programSelect: value
      });
    else{
      this.props.actions.mProjectListMap.setFilterInputs({
        filter_program: value,
        programSelect: value
      });
      this.filterList({filter_program: value});
    }
  };
  projectStatus_onChange = (value) => {
    //console.log(`projectStatus_onChange`, this.props.mProjectListMap.isFilteringOpen, value);
    if(this.props.mProjectListMap.isFilteringOpen){
      this.props.actions.mProjectListMap.setFilterInputs({
        filter_projectStatus_temp: value,
        projectStatusSelect: value
      });
    }
    else{
      this.props.actions.mProjectListMap.setFilterInputs({
        filter_projectStatus: value,
        projectStatusSelect: value
      });
      this.filterList({filter_projectStatus: value});
    }
  };
  projectTypeList_onFilter = filter => {
    //console.log(`projectTypeList_onFilter`, this.props.projectTypeList.selectedProjectTypes, filter);

    let selectedProjectTypes = [...this.props.projectTypeList.selectedProjectTypes || []];
    if(selectedProjectTypes.indexOf(filter) >= 0)
      selectedProjectTypes.splice(selectedProjectTypes.indexOf(filter), 1);
    else
      selectedProjectTypes.push(filter);

    if(this.props.mProjectListMap.isFilteringOpen){
      this.props.actions.mProjectListMap.setFilterInputs({filter_projectType_temp: selectedProjectTypes});
      this.props.actions.projectTypeList.filterList(selectedProjectTypes);
    }
    else{
      this.props.actions.mProjectListMap.setFilterInputs({filter_projectType: selectedProjectTypes});
      this.filterList({filter_projectType: selectedProjectTypes});
    }
  };
  search_onBlur = () => {
    this.props.actions.mProjectListMap.toggleSearch(false);
  };
  search_onClearClick = () => {
    this._draftQuery = '';
    this.setState({searchBusy: false});
    this.props.actions.mProjectListMap.setFilterInputs({filter_title: ''});
    this.handleSearch('');
    this.filterList({filter_title: ''});
    this.props.actions.mProjectListMap.toggleSearch(false);
  };
  search_onFocus = () => {
    const query = this.props.mProjectListMap.filter_title || '';
    this.props.actions.mProjectListMap.toggleSearch(query.length > 0);
    if(query.length > 0){
      this._draftQuery = query;
      this.setState({searchBusy: true});
      this.handleSearch(query);
    }
  };
  search_onInputChange = event => {
    const value = event ? event.target.value : '';
    this._draftQuery = value;
    const isSearchOpen = value.length > 0;
    if(Boolean(this.props.mProjectListMap.isSearchOpen) !== isSearchOpen){
      this.props.actions.mProjectListMap.toggleSearch(isSearchOpen);
    }
    this.setState({searchBusy: Boolean(value)});
    this.handleSearch(value);
  };
  search_onSubmit = event => {
    const query = this.getSearchQueryFromEvent(event);
    this.setState({searchBusy: true});
    this.props.actions.mProjectListMap.setFilterInputs({filter_title: query});
    this.props.actions.mProjectListMap.toggleSearch(false);
    this.handleSearch('');
    Promise.resolve(this.filterList({filter_title: query}))
      .then(() => this.setState({searchBusy: false}))
      .catch(() => this.setState({searchBusy: false}));
  };
  getSearchQueryFromEvent = event => {
    if(!event || !event.currentTarget){
      return '';
    }
    const form = event.currentTarget;
    const field = form.elements && form.elements.query;
    if(field){
      return field.value || '';
    }
    return new FormData(form).get('query') || '';
  };
  viewToggle_listView_onClick = () => {
    this.props.actions.mProjectListMap.setViewMap(false);
    this.filterList({viewMap: false});
  };
  viewToggle_mapView_onClick = () => {
    this.props.actions.mProjectListMap.setViewMap(true);
    this.filterList({viewMap: true});
  };


  filterList = (opts) => {
    let filters = {
      ProjectTypes_in: typeof opts.filter_projectType != 'undefined' ? opts.filter_projectType : this.props.mProjectListMap.filter_projectType,
      projectstatus_in: typeof opts.filter_projectStatus != 'undefined' ? opts.filter_projectStatus : this.props.mProjectListMap.filter_projectStatus,
      Program_in: typeof opts.filter_program != 'undefined' ? opts.filter_program : this.props.mProjectListMap.filter_program,
      Title_contains: typeof opts.filter_title != 'undefined' ? opts.filter_title : this.props.mProjectListMap.filter_title,
      viewMap: typeof opts.viewMap != 'undefined' ? opts.viewMap : this.props.mProjectListMap.viewMap
    };
    this.props.actions.mProjectListMap.filterList(filters);
    this.props.actions.projectTypeList.filterList(typeof opts.filter_projectType != 'undefined' ? opts.filter_projectType : this.props.mProjectListMap.filter_projectType);

    const searchString = helpers.encodeData(helpers.cleanObj({
      ...filters,
      viewMap: filters.viewMap ? 'true' : undefined,
    }));
    const nextSearch = searchString ? `?${searchString}` : '';
    this.lastAppliedSearch = nextSearch;
    this.props.history.push({
      pathname: '/projects',
      search: nextSearch,
    });
  };
  handleMapNearByProjects = values => {
    this.setState({
      mapNearByProjects: values
    });
  };
  handleSearch = query => {
    if(!query){
      this.debouncedDoSearch.cancel();
      this.props.actions.mProjectListMap.doSearch('');
      return;
    }
    this.debouncedDoSearch(query);
  };


  renderFeaturedProjects(){
    if(this.props.mProjectListMap.suggestedProjects) return null;

    return (
      <div className="col-12">
        <MListNav cmsName={apiValues.NAV_FEATURED_PROJECTS} className="m-listnav--page-search-results"/>
      </div>
    );
  }
  renderLoadMoreButton(){
    if(this.props.mProjectListMap.hasMore === false) return null;
    if(this.props.mProjectListMap.isLoading) return null;
    // Legacy fallback when hasMore is unset: hide once the visible window catches the loaded ids.
    if(
      this.props.mProjectListMap.hasMore == null &&
      this.props.mProjectListMap.projects.length <= this.props.mProjectListMap.listLength
    ){
      return null;
    }

    return (
      <div className="text-center">
        <button className="m-projectlistmap__load-more tg-button tg-button--pill tg-button--black" onClick={this.loadMoreButton_onClick}>
          <span className="tg-button__label">Load More</span>
        </button>
      </div>
    );
  }
  renderMap(){
    const viewMap = this.props.mProjectListMap.viewMap;
    const viewClass = viewMap ? 'm-projectlistmap__map--show-map' : 'm-projectlistmap__map--inactive';

    return (
      <div className={`m-projectlistmap__map ${viewClass}`}
           aria-hidden={viewMap ? undefined : true}
           {...(viewMap ? {} : {inert: ''})}>
        <MapParent cmsId={this.props.cmsId}
                   mapInactive={!viewMap}
                   handleMapNearByProjects={this.handleMapNearByProjects}
                   history={this.props.history}/>
      </div>
    );
  }
  renderProjects(){
    let viewClass = this.props.mProjectListMap.viewMap ? 'd-none' : '';
    // ProjectStub connects to Redux by id — avoid re-rendering the whole list on every stub fetch.
    let projects = this.props.mProjectListMap.projects
      .slice(0, this.props.mProjectListMap.listLength)
      .map(projectId => ({id: projectId}));

    return (
      <div className={`m-projectlistmap__listing ${viewClass}`}>
        <div className="coupling coupling--full-centered">
          <div className="container container--coupling">
            {projects.length > 0 ?
             (<ProjectList projects={projects}/>) :
             (<div>
               <div className="no-results">
                 Sorry, but nothing matched your search criteria. Please try again with some different keywords.
               </div>
               <div className="no-results-suggestion">
                 Search Suggestions
                 <ul>
                   <li>
                     Check spelling
                   </li>
                   <li>
                     Try more general words
                   </li>
                   <li>
                     Remove some search filters
                   </li>
                   <li>
                     <a href="/get-involved" target="_blank">Contact us</a> {`if you still can't find what you are looking for`}
                   </li>
                 </ul>
               </div>
             </div>)}
          </div>
          {this.renderLoadMoreButton()}
        </div>
      </div>
    );
  }
  renderSearch(){
    const urlParams = helpers.parseUrlSearch(this.props.location.search);

    return (
      <div className="m-projectlistmap__search">
        <div className="coupling coupling--full-centered">
          <div className="container container--coupling">
            <div className="m-projectlistmap__search">
              <label id="projects-search-label" htmlFor="projects-search" className="m-projectlistmap__search-label">Search projects</label>
              <SiteSearch className={`site-search--mprojectlistmap`}
                          ariaLabelledBy="projects-search-label"
                          inputID="projects-search"
                          isOpen={this.props.mProjectListMap.isSearchOpen}
                          onBlur={this.search_onBlur}
                          onClearClick={this.search_onClearClick}
                          onFocus={this.search_onFocus}
                          onInputChange={this.search_onInputChange}
                          onSubmit={this.search_onSubmit}
                          isLoading={this.state.searchBusy}
                          inputPlaceholder="Search our projects"
                          defaultValue={urlParams.Title_contains}
                          requred={false}>
                <div className="row">
                  {this.renderFeaturedProjects()}
                  {this.renderSuggestedProjects()}
                  {this.renderViewProjectsNear()}
                </div>
              </SiteSearch>
            </div>
          </div>
        </div>
      </div>
    );
  }
  renderSuggestedProjects(){
    if(!this.props.mProjectListMap.suggestedProjects) return null;

    let mListNav = {
      title: 'Suggested Projects',
      navigationLinks: this.props.mProjectListMap.suggestedProjects.slice(0, 4).map(project => {
        return {
          key: project.id,
          title: project.title,
          url: `/projects/${project.slug ? project.slug : ''}`
        };
      }),
      highlight: this.props.mProjectListMap.searchQuery
    };

    if(this.props.mProjectListMap.suggestedProjects.length === 0){
      return (
        <div className="col-12">
          <div className="no-search-results">{`Sorry this search doesn't have any results.`}</div>
          <div className="no-results-suggestion">
            Search Suggestions
            <ul>
              <li>
                Check spelling
              </li>
              <li>
                Try more general words
              </li>
              <li>
                Remove some search filters
              </li>
              <li>
                <a href="/get-involved" target="_blank">Contact us</a> {`if you still can't find what you are looking for`}
              </li>
            </ul>
          </div>
          {/* <SuperLink to="projects" className="m-projectlistmap__results-link">View all projects for &quot;{this.state.searchQuery}&quot;</SuperLink> */}
        </div>
      );
    }

    return (
      <div className="col-12">
        <MListNav mListNav={mListNav} className="m-listnav--page-search-results"/>
      </div>
    );
  }
  renderToolbar(){
    let mapViewClass = this.props.mProjectListMap.viewMap ? 'm-projectlistmap__toolbar--map-view' : '';
    let mobileFilteringClass = this.props.mProjectListMap.isFilteringOpen ? 'm-projectlistmap__toolbar--fixed' : '';

    let programs = [{title: 'All', value: ''}].concat(
      this.props.mProjectListMap.programs
        .slice()
        .sort((a, b) => {
          return a.title.localeCompare(b.title);
        })
        .map(program => {
          return {title: program.title, value: program.id};
        })
    );
    let projectStatuses = [{title: 'All', value: ''}].concat(
      this.props.mProjectListMap.projectStatuses
        .slice()
        .sort((a, b) => {
          return a.title.localeCompare(b.title);
        })
        .map(projectStatus => {
          return {title: projectStatus.title, value: projectStatus.id};
        })
    );
    const urlParams = helpers.parseUrlSearch(this.props.location.search);

    return (
      <div className={`m-projectlistmap__toolbar ${mapViewClass} ${mobileFilteringClass}`}>
        <div className="coupling coupling--full-centered">
          <div className="text-end">
            <button className="m-projectlistmap__toolbar-close" onClick={this.filteringClose_onClick}>Close</button>
          </div>
          <div className="container container--coupling">
            <div className="m-projectlistmap__toolbar-container">
              <div className="row m-projectlistmap__toolbar-row">
                <div className="m-projectlistmap__toolbar-filters col"
                     role="group"
                     aria-labelledby="m-projectlistmap-filter-label">
                  <div className="row m-projectlistmap__toolbar-filters-row">
                    <div className="m-projectlistmap__toolbar-col-types col">
                      <div className="m-projectlistmap__toolbar-col-filter-title"
                           id="m-projectlistmap-filter-label">
                        Filter projects by
                        <button className="m-projectlistmap__toolbar-clear-all" onClick={this.filteringClear_onClick}>Clear
                          All</button>
                      </div>
                      <div className="m-projectlistmap__toolbar-col-control">
                        <ProjectTypeList defaultValue={urlParams.ProjectTypes_in}
                                         cmsName={apiValues.NAV_PROJECT_TYPES}
                                         onFilter={this.projectTypeList_onFilter}/>
                      </div>
                    </div>
                    <div className="m-projectlistmap__toolbar-col-programs col">
                      <div className="m-projectlistmap__toolbar-select-title">Program</div>
                      <div className="m-projectlistmap__toolbar-col-control">
                        <Select className="m-projectlistmap__toolbar-select"
                                defaultValue={urlParams.Program_in}
                                value={this.props.mProjectListMap.programSelect}
                                onSelectedChange={this.programsSelect_onChange}
                                options={programs}/>
                      </div>
                    </div>
                    <div className="m-projectlistmap__toolbar-col-statuses col">
                      <div className="m-projectlistmap__toolbar-select-title">Project Status</div>
                      <div className="m-projectlistmap__toolbar-col-control">
                        <Select className="m-projectlistmap__toolbar-select"
                                defaultValue={urlParams.projectstatus_in}
                                value={this.props.mProjectListMap.projectStatusSelect}
                                onSelectedChange={this.projectStatus_onChange}
                                options={projectStatuses}/>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="m-projectlistmap__toolbar-col-filter col align-self-center">
                  <button type="button"
                          className="m-projectlistmap__toolbar-filter"
                          onClick={this.filterProjectsButton_onClick}>
                    Filter Projects
                  </button>
                </div>
                <div className="m-projectlistmap__toolbar-col-toggle col text-end">
                  <div className="m-projectlistmap__toolbar-select-title m-projectlistmap__toolbar-select-title--spacer"
                       aria-hidden="true">&#8203;</div>
                  <div className="m-projectlistmap__toolbar-col-control">
                    {this.renderViewToggle()}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="m-projectlistmap__toolbar-buttons col">
            <button type="submit"
                    className="m-projectlistmap__toolbar-apply tg-button tg-button--pill tg-button--black flex-fill"
                    onClick={this.filteringApply_onClick}>
              <span className="tg-button__label">Apply</span>
            </button>
            <button type="submit"
                    className="m-projectlistmap__toolbar-cancel tg-button tg-button--pill tg-button--white flex-fill"
                    onClick={this.filteringCancel_onClick}>
              <span className="tg-button__label">Cancel</span>
            </button>
          </div>
        </div>
      </div>
    );
  }
  renderViewProjectsNear(){
    if(!this.props.mProjectListMap.viewProjectsNear) return null;

    const nearProjects = this.props.mProjectListMap.viewProjectsNear.filter(item => {
      if(!item.projectId) return false;
      return this.state.mapNearByProjects.includes(item.projectId);
    });

    let mListNav = {
      title: 'View Projects Near',
      navigationLinks: nearProjects.slice(0, 4).map(project => {
        return {
          key: project.id,
          title: project.title,
          url: project.slug
        };
      }),
      highlight: this.props.mProjectListMap.searchQuery
    };

    return (
      <div className="col-12">
        <MListNav mListNav={mListNav} className="m-listnav--page-search-results"/>
        {/* <SuperLink className="m-projectlistmap__results-link" to="projects">Use my current location</SuperLink> */}
      </div>
    );
  }
  renderViewToggle(){
    let listViewClass = !this.props.mProjectListMap.viewMap ? 'tg-button--orange' : '';
    let mapViewClass = this.props.mProjectListMap.viewMap ? 'tg-button--orange' : '';

    return (
      <div className="m-projectlistmap__view-toggle" role="group" aria-label="View mode">
        <button type="button"
                className={`m-projectlistmap__view-toggle-button tg-button tg-button--pill ${listViewClass}`}
                aria-pressed={!this.props.mProjectListMap.viewMap}
                onClick={this.viewToggle_listView_onClick}>
          <img alt="" className="tg-button__icon" src={iconViewGrid}/>
          <span className="tg-button__label">List View</span>
        </button>
        <button type="button"
                className={`m-projectlistmap__view-toggle-button tg-button tg-button--pill ${mapViewClass}`}
                aria-pressed={this.props.mProjectListMap.viewMap}
                onClick={this.viewToggle_mapView_onClick}>
          <img alt="" className="tg-button__icon" src={iconViewMap}/>
          <span className="tg-button__label">Map View</span>
        </button>
      </div>
    );
  }
  render(){
    // console.log(`MProjectListMap render`, this.props);
    if(!this.props.mProjectListMap ||
       !this.props.mProjectListMap.programs ||
       !this.props.mProjectListMap.projects ||
       !this.props.mProjectListMap.projectStatuses) return null;

    const viewMap = this.props.mProjectListMap.viewMap;

    return (
      <div className={`m-projectlistmap ${this.props.className || ''}`}>
        {this.renderSearch()}
        {this.renderToolbar()}
        {viewMap ? (
          <>
            {this.renderMap()}
            {this.renderProjects()}
          </>
        ) : (
          <>
            {this.renderProjects()}
            {this.renderMap()}
          </>
        )}
      </div>
    );
  }
}


export default withRouter(connect(
  (state) => ({
    mProjectListMap: state.mProjectListMap,
    projectTypeList: state.projectTypeList
  }),
  (dispatch) => ({
    actions: {
      mProjectListMap: bindActionCreators(mProjectListMapActions, dispatch),
      projectTypeList: bindActionCreators(projectTypeListActions, dispatch)
    }
  })
)(MProjectListMap));


MProjectListMap.propTypes = {
  actions: PropTypes.object.isRequired,
  className: PropTypes.string,
  cmsId: PropTypes.string,
  history: PropTypes.object,
  location: PropTypes.object,
  mProjectListMap: PropTypes.object,
  projectTypeList: PropTypes.object
};
